export default __webpack_public_path__ + "static/media/wife3.1809d2e0.png";